import React from 'react'
import Layout from '../components/Layout/Layout'

const PageNtFound = () => {
  return (
    <Layout>PageNtFound</Layout>
  )
}

export default PageNtFound